import React from 'react';
import { FadeIn, CTAButton, Section } from './Shared';
import { ShieldCheck, Lock, CreditCard, Star, XCircle, CheckCircle2, ArrowRight } from 'lucide-react';
export const Hero = () => {
  return <section className="bg-bg-base px-4 pt-4 pb-7 md:pt-16 md:pb-16 overflow-hidden" data-id="element-304" data-mp="rrp8ibgwjnl2">
      <div className="max-w-[700px] mx-auto text-center space-y-2.5 md:space-y-6" data-id="element-305" data-mp="wr25vq5egd1w">
        <FadeIn data-id="element-306" data-mp="wt669y43atxf">
          <div className="space-y-2 md:space-y-4" data-id="element-307" data-mp="3v97gciwoculh">
            <div className="inline-flex items-center gap-1.5 bg-bg-card text-brandGold font-sans font-bold uppercase tracking-[1.5px] text-[10px] md:text-[11px] px-3 py-1 md:px-4 md:py-1.5 rounded-full border border-brandGold/40" data-id="element-308" data-mp="3vaijcgiapybj">
              <span className="text-sm md:text-base" data-id="element-309" data-mp="e0u7flcnaas1">🎨</span>
              <span className="text-[8.5px]" data-id="element-310" data-mp="e2f2rd6s9xqy">
                MEGAPACK COLORIMETRÍA LISTA™
              </span>
            </div>
            <h1 className="font-hero font-bold uppercase text-[30px] md:text-[56px] leading-[1.08] tracking-[0.5px] text-txt-primary mx-auto max-w-[20ch] px-2 pt-3 pb-1" data-id="element-311" data-mp="1kj8vm6gmdlsc">
              <span className="block" data-id="element-312" data-mp="1h9sia9chfmxh">TODO LO QUE NECESITAS</span>
              <span className="block text-brandGold" data-id="element-313" data-mp="1cazc71ziyy7c">PARA DOMINAR LA COLORIMETRÍA</span>
              <span className="block" data-id="element-314" data-mp="1894cu315muw7">LISTO. DESDE HOY</span>
            </h1>

            <p className="text-txt-body text-[12.5px] md:text-[16px] leading-[1.4] md:leading-[1.7] font-sans px-3" data-id="element-315" data-mp="13ajcm3lwkb7r">
              15 Módulos en Video · 4 Manuales Profesionales · 5 Bonos · Curso Completo
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.15} data-id="element-316" data-mp="tjy5frs5xyd8">
          <a href="#pricing" className="block cursor-pointer relative" data-id="element-317" data-mp="tin21t2mqsmn">
            <div className="absolute inset-0 bg-brandGold/15 blur-[40px] rounded-full" data-id="element-318" data-mp="om6d4wnlwa8i"></div>
            <div className="absolute inset-y-0 -inset-x-10 bg-brandGold/10 blur-[28px] rounded-full" data-id="element-319" data-mp="klcnnyuimndi"></div>
            <img src="https://cdn.magicpatterns.com/uploads/agacHF4oUprc8XhkQK75E2/mockup_sticker.png" alt="Megapack Colorimetría Lista — Mockup completo del producto" loading="eager" decoding="async"
          // @ts-ignore — supported by modern browsers
          fetchpriority="high" className="relative block w-full max-w-[300px] md:max-w-[560px] mx-auto h-auto object-contain hover:-translate-y-1 transition-transform duration-300 drop-shadow-2xl" data-id="element-320" data-mp="fkf9dxcmmdha" />
          </a>
        </FadeIn>

        <FadeIn delay={0.25} data-id="element-321" data-mp="3s5m3jbq529xg">
          <div className="max-w-2xl mx-auto space-y-2.5 md:space-y-5" data-id="element-322" data-mp="3s6nc99jomkc0">
            {/* Chips - same on all screens */}
            <div className="flex flex-wrap gap-1.5 md:gap-2 justify-center items-center" data-id="element-323" data-mp="onudw3zh622f">
              <span className="bg-bg-card text-txt-body px-2.5 py-1 md:px-3 md:py-1.5 rounded-full text-[10.5px] md:text-sm font-sans border border-line inline-flex items-center gap-1 whitespace-nowrap" data-id="element-324" data-mp="opon4l1dw5qo">
                <span className="text-[10px] md:text-xs" data-id="element-325" data-mp="12nlnlsiykwam">📄</span> 100% PDF +
                Videos HD
              </span>
              <span className="bg-bg-card text-txt-body px-2.5 py-1 md:px-3 md:py-1.5 rounded-full text-[10.5px] md:text-sm font-sans border border-line inline-flex items-center gap-1 whitespace-nowrap" data-id="element-326" data-mp="17evcus0lhxlz">
                <span className="text-[10px] md:text-xs" data-id="element-327" data-mp="2n6fp32y0ncqv">⚡</span> Acceso en 5
                min
              </span>
              <span className="bg-bg-card text-txt-body px-2.5 py-1 md:px-3 md:py-1.5 rounded-full text-[10.5px] md:text-sm font-sans border border-line inline-flex items-center gap-1 whitespace-nowrap" data-id="element-328" data-mp="31tioxg9t9xhd">
                <span className="text-[10px] md:text-xs" data-id="element-329" data-mp="296o58lktj24y">📚</span> 475+ páginas
                + 14 h de video
              </span>
            </div>

            {/* CTA button + trust */}
            <div className="space-y-2 md:space-y-3" data-id="element-330" data-mp="2i7m8v2rch7n0">
              <CTAButton href="#pricing" fullWidth className="!py-3.5 md:!py-4 !text-[15px] md:!text-base" data-id="element-331" data-mp="2i489m3dz9ejs">
                🎨 DOMINA LA COLORIMETRÍA AHORA
              </CTAButton>

              <div className="flex flex-wrap items-center justify-center gap-2 md:gap-4 text-[9.5px] md:text-xs text-txt-muted font-sans" data-id="element-332" data-mp="3tnt3dmwpo7b1">
                <span className="flex items-center gap-1" data-id="element-333" data-mp="opf6evyy0r3z">
                  <ShieldCheck size={11} className="text-success" data-id="element-334" data-mp="or03as8qcm50" /> Garantía 7
                  días
                </span>
                <span className="flex items-center gap-1" data-id="element-335" data-mp="xpljwhun5r35">
                  <Lock size={11} className="text-txt-muted" data-id="element-336" data-mp="xoad095wg37t" /> Pago seguro
                </span>
                <span className="flex items-center gap-1" data-id="element-337" data-mp="12q9etelzqs2n">
                  <CreditCard size={11} className="text-brandGold" data-id="element-338" data-mp="17oaxhyfi8pdl" /> Pagas en
                  tu moneda local
                </span>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
};
export const SocialProof = () => {
  const stats = [{
    value: '+500',
    label: 'barberos dominan con esto'
  }, {
    value: '15',
    label: 'Módulos en video'
  }, {
    value: '4',
    label: 'Manuales PDF'
  }, {
    value: '4.9/5',
    label: 'calificación',
    star: true
  }];
  return <div className="bg-bg-alt border-y border-line py-6" data-id="element-339" data-mp="1ve5dgov4eu22">
      <div className="max-w-[1100px] mx-auto px-6" data-id="element-340" data-mp="3fv4sggj9dac4">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-center divide-x divide-line" data-id="element-341" data-mp="3fwza9lz8gmbz">
          {stats.map((stat, i) => <FadeIn key={stat.label} delay={0.1 + i * 0.1} data-id="element-342" data-mp="3ayo35j0bopxg" data-mpi={i}>
              <div className="font-display font-bold text-[30px] md:text-[42px] leading-[1.1] text-brandGold mb-0.5" data-id="element-343" data-mp="35y01m3egwqoz">
                {stat.value}
              </div>
              <div className="text-sm font-sans text-txt-body flex items-center justify-center gap-1" data-id="element-344" data-mp="2h1dni7woi58">
                {stat.label}
                {stat.star && <Star size={12} className="fill-gold text-gold" data-id="element-345" data-mp="3tnb4bqfdov5r" />}
              </div>
            </FadeIn>)}
        </div>
      </div>
    </div>;
};
export const Testimonials1 = () => {
  const testimonials = [{
    initials: 'JM',
    text: 'No sabía como realizar platinados. Con esto aprendí como hacerlos. Me ayudo mucho, gracias.',
    author: 'Juan M.',
    role: 'Barbero Profesional · Argentina',
    bg: 'bg-brandGold text-[#14100A]'
  }, {
    initials: 'CS',
    text: 'Implemente el servicio de color con mi equipo. Ahora realizamos trabajos completos. Sin errores.',
    author: 'Carlos S.',
    role: 'Dueño de Barbería · México',
    bg: 'bg-brandSteel-deep text-white'
  }, {
    initials: 'RF',
    text: 'Descargué todo el curso. Ahora lo aplicamos en el local. Me ayudo mucho a comprender qué fórmula usar.',
    author: 'Roberto F.',
    role: 'Colorista · Colombia',
    bg: 'bg-brandGold text-[#14100A]'
  }];
  return <Section className="bg-bg-base" data-id="element-346" data-mp="1vz8qjqundx8u">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-2.5 md:gap-4" data-id="element-347" data-mp="1w0a2rynegps5">
        {testimonials.map((t, i) => <FadeIn key={i} delay={Math.min(i * 0.05, 0.2)} data-id="element-348" data-mp="1i0hh4hqqczr1" data-mpi={i}>
            <div className="bg-bg-card p-3.5 md:p-5 rounded-[14px] md:rounded-[18px] border border-line h-full flex flex-col" data-id="element-349" data-mp="1myizt1k8ux1z">
              <div className="flex items-center gap-2.5 mb-2.5" data-id="element-350" data-mp="3cd792txjfyvs">
                <div className={`w-8 h-8 md:w-9 md:h-9 ${t.bg} rounded-full flex items-center justify-center font-sans font-bold text-[11px] md:text-xs shrink-0`} data-id="element-351" data-mp="3hcjvxeoet5yd">
                  {t.initials}
                </div>
                <div className="min-w-0" data-id="element-352" data-mp="10qdg14m7l995">
                  <div className="flex text-gold mb-0.5" data-id="element-353" data-mp="10rolr9z7sr2w">
                    {[...Array(5)].map((_, j) => <Star key={j} size={10} className="fill-current" data-id="element-354" data-mp="1fft7ynxh7kqf" data-mpi={j} />)}
                  </div>
                  <p className="font-sans font-bold text-txt-primary text-[12px] md:text-[13px] leading-tight" data-id="element-355" data-mp="1an9r9i3hs9he">
                    {t.author}
                  </p>
                  <p className="text-[10px] md:text-[11px] font-sans text-txt-muted" data-id="element-356" data-mp="1jgv7l5vb1ysx">
                    {t.role}
                  </p>
                </div>
              </div>
              <p className="text-txt-body font-sans text-[12.5px] md:text-[13.5px] leading-[1.5] italic" data-id="element-357" data-mp="1ybjbwgoyyr6y">
                "{t.text}"
              </p>
              <p className="font-sans font-bold uppercase tracking-[1px] text-[9px] md:text-[10px] text-brandGold mt-auto pt-2.5" data-id="element-358" data-mp="40w2y4kwckxf">
                Compró el Megapack
              </p>
            </div>
          </FadeIn>)}
      </div>
    </Section>;
};
export const UniqueMechanism = () => {
  const scattered = ['Buscaste videos en YouTube.', 'Seguiste tutoriales en Instagram.', 'Preguntaste a otros barberos.', 'Todos te enseñaron algo diferente.'];
  const chain = [{
    from: 'Diagnóstico claro',
    to: 'Fórmula exacta'
  }, {
    from: 'Fórmula exacta',
    to: 'Aplicación paso a paso'
  }, {
    from: 'Aplicación',
    to: 'Resultado garantizado'
  }];
  return <Section className="bg-bg-base" data-id="element-359" data-mp="2vd79920r1io0">
      <div className="max-w-[880px] mx-auto" data-id="element-360" data-mp="2vea5lpgucdbb">
        <FadeIn data-id="element-361" data-mp="2vf1wwo3enovs">
          
        </FadeIn>

        
      </div>
    </Section>;
};
export const Problem = () => {
  const painPoints = ['Aprendiste técnicas, fórmulas o trabajos complejos buscando videos por tu cuenta', 'No sientes la confinanza para decolorar y neutralizar sin arruinar el cabello', 'Repites los mismos trabajos porque no tienes un banco completo de diseños con ideas organizadas', 'Un cliente nuevo pide un "platinado blanco" y no sabes que tintura utilizar exactamente', 'Conoces sobre el tema, pero no lo dominas realmente y tus colores quedan con detalles amarillos', 'Cada mes pierdes ingresos extras por rechazar trabajos o cobrarlos a un precio que no es rentable'];
  return <Section className="bg-bg-alt" data-id="element-362" data-mp="1vb2agpv6w7ya">
      <div className="max-w-[720px] mx-auto" data-id="element-363" data-mp="1qf3rjhsmri59">
        <FadeIn data-id="element-364" data-mp="1qc7sfq51qnf8">
          <h2 className="font-display font-bold uppercase md:text-[36px] text-center mb-8 text-txt-primary text-[22px] leading-[1.25] tracking-[0.5px]" data-id="element-365" data-mp="1qchgh86j6kia">
            Si estás en el mundo de la <span className="text-brandGold" data-id="element-366" data-mp="1gi8tt146lls1">barbería,</span>
            <br data-id="element-367" data-mp="1cfkjeoztk6sy" />
            esto te va a sonar familiar...
          </h2>

          <div className="space-y-2 md:space-y-3 mb-10" data-id="element-368" data-mp="17fzjocctruf6">
            {painPoints.map((point, i) => <div key={i} className="flex items-start gap-2.5 bg-bg-card border border-line rounded-[10px] py-2.5 px-3 md:py-3 md:px-4" data-id="element-369" data-mp="36sk7l6i9m9bu" data-mpi={i}>
                <XCircle className="text-danger shrink-0 mt-0.5" size={16} data-id="element-370" data-mp="31uiju89w9lu1" />
                <p className="text-txt-body font-sans text-[13px] md:text-[15px] leading-[1.5]" data-id="element-371" data-mp="ib51nxpibnxk">
                  {point}
                </p>
              </div>)}
          </div>

          {/* Gold divider */}
          <div className="h-[2px] w-32 md:w-48 mx-auto rounded-full mb-10 md:mb-12 bg-brandGold" style={{
          boxShadow: '0 0 12px rgba(212,162,76,0.7), 0 0 24px rgba(212,162,76,0.4)'
        }} data-id="element-372" data-mp="rcl4nkdzsnrr"></div>

          <h3 className="font-display font-bold uppercase md:text-[40px] text-center text-txt-primary mb-8 relative text-[24px] leading-[1.2] tracking-[0.5px]" data-id="element-373" data-mp="3uu39rk2drgoh">
            ¿Sigues improvisando con tus clientes{' '}
            <span className="text-brandGold inline-block" style={{
            textShadow: '0 0 20px rgba(212,162,76,0.5), 0 0 40px rgba(212,162,76,0.3)'
          }} data-id="element-374" data-mp="8f1ps04usaxf">
             por tener un conocimiento disperso?
            </span>
          </h3>

          <div className="space-y-4 text-txt-body font-sans text-[15px] md:text-base leading-[1.7] mb-10" data-id="element-375" data-mp="373qrbf9ie1jn">
            <p style={{
            paddingLeft: "10px"
          }} data-id="element-376" data-mp="1mkwr0866tr4z">
              Elegiste este camino porque amas esta profesión, trabajar en la imagen de tus
              clientes y ganar dinero en serio.
            </p>
            <p style={{
            paddingLeft: "9px"
          }} data-id="element-377" data-mp="1dm1l6x722j27">
              Pero nadie te dijo que ibas a perder tiempo improvisando sobre el cliente, sin
              encontrar EL SECRETO EXACTO donde TODO esté organizado, donde NO FALLES y
              puedas COBRAR lo que realmente vale tu trabajo.
            </p>
          </div>

          {/* Highlighted closing question */}
          <div className="relative bg-bg-card border-2 border-brandGold rounded-[16px] py-5 px-5 md:py-6 md:px-8 shadow-[0_0_40px_rgba(212,162,76,0.2)]" data-id="element-378" data-mp="1wa6ltvsf1nws">
            <p className="font-display font-bold text-[18px] md:text-[26px] leading-[1.3] text-center text-txt-primary uppercase tracking-[0.5px]" data-id="element-379" data-mp="kw2rupltvzrq">
              ¿Y SI HOY TUVIERAS TODO LISTO PARA{' '}
              <span className="text-brandGold" data-id="element-380" data-mp="5t1morumxje9">DOMINAR LA TÉCNICA?</span>
            </p>
          </div>

          {/* Gold divider — transition to product */}
          <div className="h-[2px] w-32 md:w-48 mx-auto rounded-full mt-10 md:mt-14 bg-brandGold" style={{
          boxShadow: '0 0 12px rgba(212,162,76,0.7), 0 0 24px rgba(212,162,76,0.4)'
        }} data-id="element-381" data-mp="1rzl44d8wv94"></div>
        </FadeIn>
      </div>
    </Section>;
};